/* eslint-disable no-unused-vars */
import { defineStore } from "pinia";
import http from "../config/apiConfig";

export const useStockMovementStore = defineStore("stockmovement", {
    actions: {
        async txSummaryFetch(payload) {
            const body = {
                groupUid: payload.groupUid,
                shopUid: payload.shopUid,
            };
            return new Promise((resolve, reject) => {
                try {
                    const pathUrl = "/pawn-rpt-svc/stockMove/sum";
                    const response = http.post(pathUrl, body);
                    resolve(response);
                } catch (e) {
                    reject(e);
                }
            });
        },

    },
});